import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import { Button, ButtonsContainer } from '@forma/forma-ui-kit';

import styles from './document-html.module.css';

const createRow = (container, data, dataTotal, isHeader = false) => {
  const row = container.insertRow();

  data.forEach((item) => {
    const cell = document.createElement(isHeader ? 'th' : 'td');
    cell.textContent = isHeader ? item.name : '\u200B';
    cell.colSpan = data.length === 1 && dataTotal?.length ? 2 : undefined;
    cell.style.width = item.width;
    row.append(cell);
  });
};

const createTotal = (container, dataTable, dataTotal) => {
  if (!dataTotal.length) return;

  dataTotal.forEach((item) => {
    const row = container.insertRow();
    row.classList.add('products-table-row-total');
    const nameCell = document.createElement('td');
    nameCell.textContent = item.name;
    nameCell.style.border = 0;
    nameCell.colSpan = dataTable.length > 1 ? dataTable.length - 1 : undefined;
    row.append(nameCell);

    const valueCell = document.createElement('td');
    valueCell.textContent = '\u200B';

    row.append(valueCell);
  });
};

const DocumentHTML = ({ contentHTML }) => {
  const { t } = useTranslation();
  const [htmlDOM, setHTMLDOM] = useState(null);

  const preventCopy = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    const dataAttrForDelete = ['totalCountItems', 'totalPrice'];
    const colorsBg = ['#D5EDD5', '#CCE2F2', 'EEEDC9', '#DAB5FF', '#F5DADA'];

    if (contentHTML) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(contentHTML, 'text/html');
      const content = doc.querySelector('body');
      const productsTables = doc.querySelectorAll('section.products-table');
      const variations = doc.querySelectorAll('section.variations');
      // const figureTable = doc.querySelectorAll('figure.table');
      const variables = doc.querySelectorAll('span.variable');
      const variablesOnPage = new Set();

      if (variables.length) {
        variables.forEach((variable) => {
          variablesOnPage.add(variable.getAttribute('data-side'));
        });
        const nameVarisble = Array.from(variablesOnPage);

        // variables.forEach((variable) => {
        //   const index = nameVarisble.indexOf(variable.getAttribute('data-side'));
        //   if (index === -1) return;
        //   if (nameVarisble.length <= colorsBg.length) {
        //     variable.style.backgroundColor = colorsBg[index <= colorsBg.length ? index : index - colorsBg.length];
        //   }
        // });
      }

      if (productsTables.length) {
        productsTables.forEach((section) => {
          const jsonTable = JSON.parse(section.getAttribute('data-columns'));
          const jsonDataTotal = JSON.parse(section.getAttribute('data-total'));

          const table = document.createElement('table');
          const thead = table.appendChild(document.createElement('thead'));
          const tbody = table.appendChild(document.createElement('tbody'));

          createRow(thead, jsonTable, jsonDataTotal, true);
          createRow(tbody, jsonTable, jsonDataTotal);
          createTotal(tbody, jsonTable, jsonDataTotal);

          const tableContent = section.querySelector('.products-table-content');
          tableContent.innerHTML = '';
          tableContent.append(table);

          const tableFooter = section.querySelector('.products-table-footer');
          if (tableFooter) {
            const tableFooterSpans = tableFooter.querySelectorAll('span');
            tableFooterSpans?.forEach((span) => {
              if (dataAttrForDelete.includes(span.getAttribute('data-type'))) {
                span.innerHTML = '_____________';
              }
            });
          }
        });
      }

      if (variations.length) {
        variations.forEach((section) => {
          const tabs = section.querySelectorAll('.variations-tabs__tab');
          const content = section.querySelectorAll('.variations-description');

          const variationsBlock = document.createElement('div');
          variationsBlock.classList.add(styles.variationsBlock);

          tabs.forEach((item, index) => {
            const tab = document.createElement('div');
            tab.append(tabs[index]);
            tab.append(content[index]);
            variationsBlock.append(tab);
          });

          section.append(variationsBlock);
          section.querySelector('.variations-tabs').remove();
          section.querySelector('.variations-content').remove();
        });
      }

      // if (figureTable.length) {
      //   figureTable.forEach((elem) => {
      //     const table = elem.querySelector('table');
      //     table?.setAttribute('border', '1');
      //   })
      // }

      doc.querySelectorAll('table').forEach((elem) => {
        elem.classList.add('styled-scrollbar');
      });

      setHTMLDOM(content.innerHTML);

      document.addEventListener('copy', preventCopy);
      document.addEventListener('cut', preventCopy);
    }

    return () => {
      document.removeEventListener('copy', preventCopy);
      document.removeEventListener('cut', preventCopy);
    };
  }, [contentHTML]);

  const scrollToBlockFunction = (idElement) => {
    const element = document.getElementById(idElement);
    if (!element) return;
    const elementPosition =
      element.getBoundingClientRect().top + window.scrollY - 70;
    window.scrollTo({ top: elementPosition, behavior: 'smooth' });
  };

  const handleClickFillTemplate = () => {
    document.body.style.overflow = 'auto';
    setTimeout(() => {
      scrollToBlockFunction('fill-document');
    }, 200);
  };

  if (contentHTML) return (
    <div className={styles.root}>
      <div
        className={classNames(styles.content, 'ck-editor__editable')}
        dangerouslySetInnerHTML={{ __html: htmlDOM }}
        onCopy={preventCopy}
        onCut={preventCopy}
      />
      <ButtonsContainer className={styles.buttons}>
        <Button
          onClick={handleClickFillTemplate}
        >
          {t('fill_this_template')}
        </Button>
      </ButtonsContainer>
    </div>
  );

  return null;
};

export default DocumentHTML;
